import { render, staticRenderFns } from "./OpzioniLavorazioni.vue?vue&type=template&id=b7b24cd8&scoped=true"
import script from "./OpzioniLavorazioni.vue?vue&type=script&lang=ts"
export * from "./OpzioniLavorazioni.vue?vue&type=script&lang=ts"
import style0 from "./OpzioniLavorazioni.vue?vue&type=style&index=0&id=b7b24cd8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b24cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7b24cd8')) {
      api.createRecord('b7b24cd8', component.options)
    } else {
      api.reload('b7b24cd8', component.options)
    }
    module.hot.accept("./OpzioniLavorazioni.vue?vue&type=template&id=b7b24cd8&scoped=true", function () {
      api.rerender('b7b24cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniLavorazioni.vue"
export default component.exports